"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com/dealforgerealestate",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com/dealforgerealestate",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com/company/dealforgerealestate",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "https://twitter.com/dealforgere",
    label: "Twitter"
  }];
  const navLinks = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "Approach",
    href: "#"
  }, {
    label: "Services",
    href: "#"
  }, {
    label: "Experience",
    href: "#"
  }, {
    label: "Contact",
    href: "#"
  }];
  return <footer id="footer" className="bg-primary text-foreground-primary py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start mb-12">
          {}
          <div className="flex justify-start">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542976/img/image_00gdpf89.png" alt="DealForge Real Estate Advisory" className="h-7" />
          </div>

          {}
          <nav className="grid grid-cols-2 gap-4 md:gap-6">
            {navLinks.map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-foreground-primary/80 hover:text-accent text-sm uppercase tracking-wide font-medium transition-colors duration-[var(--duration-fast)]">
                {link.label}
              </Link>)}
          </nav>
        </div>

        {}
        <div className="flex justify-center md:justify-start gap-6 mb-8">
          {socialLinks.map((social, i) => {
          const IconComponent = social.icon;
          return <Link key={i} data-index={i} to={social.href} newTab aria-label={social.label} className="text-muted hover:text-accent transition-colors duration-[var(--duration-fast)]">
                <IconComponent className="w-5 h-5" strokeWidth={1.5} />
              </Link>;
        })}
        </div>

        {}
        <Separator className="bg-accent/30 mb-6" />

        {}
        <div className="text-center md:text-left">
          <p className="text-foreground-primary/60 text-sm">
            &copy; {currentYear} DealForge Real Estate Advisory. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}